package editor.ui

import common.dto.ElementType
import common.dto.elementClasses
import editor.EditorManager
import editor.ImportExportManager
import editor.capture.CaptureManager
import editor.ui.ControlManager.brickControl
import editor.ui.ControlManager.control
import editor.ui.DropdownManager.brickDropdown
import editor.ui.DropdownManager.dropdown
import kotlinx.browser.document
import kotlinx.html.TagConsumer
import kotlinx.html.div
import kotlinx.html.dom.append
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement
import org.w3c.dom.asList

object EditorHtml {
    /**
     * Updates the currently selected element type in the ui.
     *
     * Called automatically in the setter when [EditorManager.toBePlacedType] is changed.
     */
    fun updatePlaceTypeInUi(newType: ElementType) {
        val elementClass =
            elementClasses.toList().firstOrNull { (_, elementTypes) ->
                elementTypes.contains(newType)
            }?.first ?: return

        document.querySelectorAll(".brick").asList().forEach {
            (it as? HTMLElement)?.classList?.remove("selected")
        }

        document.querySelector(".brick.${EditorUiHelper.idForName(elementClass)}")?.let {
            (it as? HTMLElement)?.classList?.add("selected")
        }

        // update dropdown items
        document.querySelectorAll(".brick .dropdown-item").asList().forEach {
            (it as? HTMLElement)?.classList?.remove("selected")
        }

        document.querySelector(".brick.${EditorUiHelper.idForName(elementClass)} .item-${newType.name}")?.classList?.add(
            "selected"
        )
    }

    /**
     * Whether the control ui on the right is collapsed. Persists the state in a cookie.
     */
    private var hideControls = ("hideControls=true" in document.cookie)
        set(value) {
            field = value
            hideUi(value)
            document.cookie = "hideControls=$value"
        }

    /**
     * Maybe "hides" (collapses) the control ui.
     *
     * Called when the [hide] variable is updated and once after the ui is added to the document.
     */
    private fun hideUi(hide: Boolean) {
        document.querySelectorAll(".controls").asList().forEach {
            (it as? Element?)?.classList?.toggle("fullscreen", hide)
        }
        document.querySelector(".control-einklappen")?.classList?.toggle("selected", hide)
    }

    /**
     * Adds the main editor ui to the given [parent].
     *
     * This includes the controls on the right side and the floating action button.
     */
    fun addHtmlTo(parent: TagConsumer<HTMLElement>) {
        parent.div("controls-container") {
            parent.div("controls").append controls@{
                div("control-group") {
                    dropdown("Speichern", additionalClasses = setOf(
                        "top-rounded",
                        "small-icon",
                        // when the controls are collapsed show the dropdown items as a floating overlay to the left
                        "floating-content-left"
                    ), content = listOf(
                        DropdownItem("JSON-Datei") {
                            ImportExportManager.export()
                        },
                        DropdownItem("Als Anleitung") {
                            CaptureManager.startExport()
                        },
//                        DropdownItem("In Account") {
//                            CaptureManager.startExport()
//                        }
                    ))
                    dropdown("Laden", additionalClasses = setOf(
                        "bottom-rounded",
                        "small-icon",
                        // when the controls are collapsed show the dropdown items as a floating overlay to the left
                        "floating-content-left"
                    ), content = listOf(
                        DropdownItem("JSON-Datei") {
                            ImportExportManager.import()
                        },
//                        DropdownItem("Von Account") {
//                             todo
//                        }
                    ))
                }
                div("control-group") {
                    control("Undo", additionalClasses = setOf("disabled")) { _, _ ->
                        EditorManager.undo()
                    }
                    control("Redo", additionalClasses = setOf("disabled")) { _, _ ->
                        EditorManager.redo()
                    }
                }
                div("control-group") {
                    elementClasses.forEach { (elementClass, elementTypes) ->
                        if (elementTypes.size > 1) {
                            // dropdown for separate lengths
                            brickDropdown(elementClass)
                        } else brickControl(elementClass, elementTypes.first())
                    }
                }
                control("Einklappen", reversible = true, selectedIcon = true, startSelected = hideControls) { element, _ ->
                    hideControls = !element.classList.contains("selected")
                }
            }
        }

        EditorInstructions.addHtmlTo(parent)
        CaptureManager.addHtmlTo(parent)
        ImportExportManager.setup(parent)

        // we have to call this here AFTER the ui is added to the document
        hideUi(hideControls)
    }
}